export default __webpack_public_path__ + "static/media/SWT0340.34I-20324_-16946_0.b175dae6.jpg";